<div class="auth-page auth-page--flow">
  <div class="auth-page__grid">
    <app-auth-showcase-aside />

<main class="auth-main auth-main--flow auth-main--dense">
      <div class="auth-main__content">
        <nav class="auth-mobile-nav" [attr.aria-label]="'auth.login.back' | translate">
          <a
            class="auth-back auth-back--icon"
            routerLink="/authentication/login"
            [attr.aria-label]="'auth.login.back' | translate"
          >
            <i-tabler name="chevron-left" class="auth-back__icon flex"></i-tabler>
          </a>
        </nav>

        <a class="auth-brand" [routerLink]="['/authentication']">
          <img
            src="/assets/images/logos/logo.svg"
            class="auth-brand__logo"
            [attr.alt]="'auth.login.logoAlt' | translate"
          />
        </a>

        <div class="auth-panel">
          <h1 class="auth-panel__title">{{ 'auth.forgotPassword.title' | translate }}</h1>
          <p class="auth-panel__subtitle">{{ 'auth.forgotPassword.subtitle' | translate }}</p>

          <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()" authScrollOnFocus>
            <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
              <mat-label>{{ 'auth.forgotPassword.email' | translate }}</mat-label>
              <input
                matInput
                type="email"
                inputmode="email"
                autocomplete="email"
                formControlName="email"
              />
              <mat-error>
                @if (f['email'].hasError('required')) {
                  {{ 'auth.forgotPassword.emailRequired' | translate }}
                } @else if (f['email'].hasError('pattern')) {
                  {{ 'auth.forgotPassword.emailInvalid' | translate }}
                }
              </mat-error>
            </mat-form-field>

            <button
              mat-flat-button
              color="primary"
              class="auth-btn-primary"
              type="submit"
              [disabled]="isSubmitting"
            >
              @if (isSubmitting) {
                <mat-spinner diameter="20" aria-hidden="true"></mat-spinner>
                {{ 'auth.forgotPassword.submitting' | translate }}
              } @else {
                {{ 'auth.forgotPassword.submit' | translate }}
              }
            </button>

            @if (errorMessage) {
              <p class="auth-form-error" role="alert">{{ errorMessage }}</p>
            }
          </form>
        </div>
      </div>
    </main>
  </div>
</div>
